import ReactDOM from 'react-dom/client'
import { StrictMode } from 'react'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './top-level/App/App'
import { GlobalContext, useGlobalContext, GlobalContextProps } from 'common/context/GlobalContext'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

root.render(
    <StrictMode>
        <Router>
            <App />  
        </Router>
    </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
